import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Appearance, Button, Icon } from "@blasterjs/core";
import { Image } from "../models";
import TopBar from "./TopBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import KeyboardShortcutDialog from "./KeyboardShortcutDialog";

interface Props {
  readonly image: Image | null;
}

const TopBarImage = ({ image }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  // smart redirect
  const close = (image: Image) => () => {
    const from = location.state?.from;
    const knownRoutes = [
      "/image-management/annotations",
      "/image-management/images",
      "/image-management/cases",
      "/queries/images"
    ];

    if (knownRoutes.includes(from)) {
      navigate(from);
    } else {
      navigate(`/studies/${image.studyId}/images`);
    }
  };

  const imageName = image === null ? null : image.name;
  const closeButton =
    image === null ? null : (
      <Button color="#fff" appearance={Appearance.MINIMAL} onClick={close(image)}>
        <Icon name="close" />
      </Button>
    );

  const [isKeyboardShortcutDialogOpen, setKeyboardShortcutDialogOpen] = useState<boolean>(false);
  const keyboardShortcutButton = (
    <>
      <Button
        className="transparent-keyboard-shortcut-button"
        style={{ marginLeft: "auto", marginRight: "1rem" }}
        onClick={() => setKeyboardShortcutDialogOpen(true)}
      >
        <FontAwesomeIcon
          icon={faQuestionCircle}
          size="2x"
          style={{ color: "#C3C3C3", transform: "scale(0.75)" }}
        />
      </Button>
    </>
  );

  return (
    <TopBar>
      {closeButton}
      {imageName}
      {keyboardShortcutButton}
      <KeyboardShortcutDialog
        isOpen={isKeyboardShortcutDialogOpen}
        setOpenDialog={setKeyboardShortcutDialogOpen}
      />
    </TopBar>
  );
};

export default TopBarImage;
